import styled from "styled-components";

export const Container = styled.div`
    margin: 1rem 0 0 1rem;
`

export const RegionsContent = styled.div`
    display: flex;
    align-items: center;

    p{
        font-size: 1.2rem;
    }
`